import { Component, Inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { ToasterStatus } from '../../../core/enums/toaster-status.enum';
import { IToasterCustomData } from '../../../core/models/toaster-config.model';

@Component({
  selector: 'laps-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
})
export class ToasterComponent {
  readonly ToasterStatus = ToasterStatus;

  constructor(
    public snackBarRef: MatSnackBarRef<ToasterComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public customData: IToasterCustomData
  ) {}
}
